module.exports = __webpack_public_path__ + "static/media/Ex2-S2VideoCover.bdc7d19d.PNG";